export default "__VITE_ASSET__CKj3xNxk__"